// extracted by mini-css-extract-plugin
export default {"wrap":"UF-z","subtitle":"VF-z","contentWrap":"WF-z","imgWrap":"XF-z","heading":"YF-z","copy":"ZF-z"};